import * as React from 'react';
import { Col, Panel, Row, FormGroup, FormControl, Button, ControlLabel, Form } from 'react-bootstrap';
import HomeBloodDrawNav from './nav';

interface IProps {
    centerId: number
}

class HomeBloodDraw extends React.Component<IProps, {}> {
    render = () => {
        const hrefPrefix = `/center/${this.props.centerId}/action-center/home-blood-draw`;

        return (
            <div className='container'>
                <Row>
                    <Col md={12}>
                        <h3>Home Blood Draw Service</h3>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <div style={{ marginBottom: 10 }}>Please use this page to order a custom blood draw kit, or a blood draw without a kit.</div>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: 10 }}>
                                <Button bsStyle='primary' href={hrefPrefix + '/order'}>
                                    Start Home Blood Draw
                                </Button>
                            </div>

                            <div>
                                <Button bsStyle='primary2' href={hrefPrefix + '/streamlined-serology'}>
                                    Start Streamlined Serology
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    };
}


export default HomeBloodDraw;
